import VisitorPassEngine from '../domain/visitorPassEngine';

const engine = new VisitorPassEngine();

export const getCurrentVisitorPass = state => {
    const { cards, location } = state;
    const { currentQrCode } = cards;

    const pass = currentQrCode ? cards.passes[currentQrCode] : null;

    return pass ? engine.validateVisitorPass(pass, location) : null;
};